import toggleBoolStringAttr from 'views/utils/toggleBoolStringAttribute'
import { ARIA_CONTROLS, ARIA_EXPANDED, ARIA_HIDDEN } from './consts'

const SELECTOR_TOOLTIP_BUTTON = '[data-clientside-hook~="tooltip__button"]'

export default () => {
  const tooltipButtons = document.querySelectorAll(SELECTOR_TOOLTIP_BUTTON)
  const rootElement = document.querySelector('.root')

  return Array.prototype.map.call(tooltipButtons, tooltipButton => {
    /** @type HTMLElement */
    const tooltipText = document.querySelector(
      `#${tooltipButton.getAttribute(ARIA_CONTROLS)}`
    )

    let isHidden = tooltipText.getAttribute(ARIA_HIDDEN) === 'true'

    const handleVisibility = isTooltipHidden => {
      toggleBoolStringAttr(tooltipButton, ARIA_EXPANDED, !isTooltipHidden)
      toggleBoolStringAttr(tooltipText, ARIA_HIDDEN, isTooltipHidden)
    }

    const hideTooltip = () => {
      isHidden = true
      handleVisibility(isHidden)
      rootElement.removeEventListener('click', hideTooltip)
    }

    const onClick = event => {
      event.stopPropagation()
      isHidden = !isHidden
      handleVisibility(isHidden)
      rootElement.addEventListener('click', hideTooltip)
    }

    tooltipButton.addEventListener('click', onClick)
  })
}
